import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import {
  AllocationViewDeleteAction,
  AllocationViewDeleteSetInitialState,
} from './allocation-view-delete-action.actions';
import { AllocationViewDeleteActionState } from './allocation-view-delete-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewDeleteActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewDeleteActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(comment?: string): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewDeleteAction({
            identifier,
            comment,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewDeleteSetInitialState());
  }
}
